import React, { useTransition } from "react";
import HorizontalDivider from "../HorizontalDivider/HorizontalDivider";
import { useTranslation } from "react-i18next";

interface AssignBuildingTitleProps {
  title?: string;
}

const AssignBuildingTitle: React.FC<AssignBuildingTitleProps> = ({ title }) => {
  const { t } = useTranslation(["assignBuilding", "invoice"]);
  return (
    <>
      <h1 className="px-3 mt-2 mb-3 assign-building-title">
        {title ? t(title) : t("assignNewProperty")}
      </h1>
      {<HorizontalDivider />}
    </>
  );
};

export default AssignBuildingTitle;
